import PhotoEventServiceIcon from '@icons/PhotoEventServiceIcon';
// import AudioServiceIcon from '@icons/AudioServiceIcon';
import CalendarServiceIcon from '@icons/CalendarServiceIcon';
import CharityServiceIcon from '@icons/CharityServiceIcon';
import CompetitionServiceIcon from '@icons/CompetitionServiceIcon';
// import ConselingCenterServiceIcon from '@icons/ConselingCenterServiceIcon';
// import EstateServiceIcon from '@icons/EstateServiceIcon';
// import FoodServiceIcon from '@icons/FoodServiceIcon';
// import GuideServiceIcon from '@icons/GuideServiceIcon';
import HandlingComplintsService from '@icons/HandlingComplintsService';
import HotelServiceIcon from '@icons/HotelServiceIcon';
// import ImageServiceIcon from '@icons/ImageServiceIcon';
// import ImamRezaServiceIcon from '@icons/ImamRezaServiceIcon';
import LibraryServiceIcon from '@icons/LibraryServiceIcon';
import LikeQuranService from '@icons/LikeQuranService';
// import LiveServiceIcon from '@icons/LiveServiceIcon';
// import MapServiceIcon from '@icons/MapServiceIcon';
import MarrigeServiceIcon from '@icons/MarrigeSerivceIcon';
import MilitaryServiceIcon from '@icons/MilitaryServiceIcon';
import MuseumServiceIcon from '@icons/MuseumServiceIcon';
import ParkingServiceIcon from '@icons/ParkingServiceIcon';
import PilgrimageServiceIcon from '@icons/PilgrimageServiceIcon';
import PrayServiceIcon from '@icons/PrayServiceIcon';
import PublicSupervisionServiceIcon from '@icons/PublicSupervisionServiceIcon';
// import QuestionServiceIcon from '@icons/QuestionServiceIcon';
import RoutingServiceIcon from '@icons/RoutingServiceIcon';
import ServantServiceIcon from '@icons/ServantServiceIcon';
import ServicePatternIcon from '@icons/ServicePatternIcon';
import ShrineProgramServiceIcon from '@icons/ShrineProgramServiceIcon';
// import VideoServiceIcon from '@icons/VideoServiceIcon';
import VirtualPilgrimageServiceIcon from '@icons/VirtualPilgrimageServiceIcon';
import RadioServiceIcon from '@icons/RadioServiceIcon';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Typography, Tooltip} from '@mui/material';
import DynamismServiceIcon from '@icons/DynamismServiceIcon';
import FirstPilgrimageServiceIcon from '@icons/FirstPilgrimageServiceIcon';
import ChannelsServiceIcon from '@icons/ChannelsServiceIcon';

export interface IService {
	id: number;
	name: string;
	icon: JSX.Element;
	link: string;
	isLocal?: boolean;
}

export interface IColorService {
	[key: string]: {
		icon: JSX.Element
	};
}

const servicesList: IService[] = [
	{
		id: 37,
		name: 'channels_list',
		icon: <ChannelsServiceIcon/>,
		link: '/channels',
		isLocal: true
	},
	{
		id: 1,
		name: 'calendar',
		icon: <CalendarServiceIcon/>,
		link: '/calendar',
		isLocal: true
	},
	{
		id: 33,
		name: 'parking',
		icon: <ParkingServiceIcon/>,
		link: '/parking',
		isLocal: true
	},
	{
		id: 34,
		name: 'dynamisms',
		icon: <DynamismServiceIcon/>,
		link: '/dynamisms',
		isLocal: true
	},
	// {
	// 	id: 5,
	// 	name: 'radio_razavi',
	// 	icon: <RadioServiceIcon/>,
	// 	link: '/radio',
	// 	isLocal: true
	// },
	{
		id: 35,
		name: 'competitions',
		icon: <CompetitionServiceIcon/>,
		link: '/competitions',
		isLocal: true
	},
	// {
	// 	id: 36,
	// 	name: 'first_pilgrimage',
	// 	icon: <FirstPilgrimageServiceIcon/>,
	// 	link: 'https://nazr.razavi.ir/fa/347786/%D8%B2%DB%8C%D8%A7%D8%B1%D8%AA-%D8%A7%D9%88%D9%84%DB%8C-%D9%87%D8%A7'
	// },
	// {
	// 	id: 10,
	// 	name: 'culture_competition',
	// 	icon: <CompetitionServiceIcon/>,
	// 	link: '/competition-old',
	// 	isLocal: true
	// },
	{
		id: 8,
		name: 'routing',
		icon: <RoutingServiceIcon/>,
		link: '/routing',
		isLocal: true
	},
	{
		id: 2,
		name: 'hotel_service',
		icon: <HotelServiceIcon/>,
		link: 'https://zaer.razavi.ir'
	},
	{
		id: 11,
		name: 'pilgrimage',
		icon: <PilgrimageServiceIcon/>,
		link: 'https://haram.razavi.ir/ziyarat'
	},
	{
		id: 4,
		name: 'charity_service',
		icon: <CharityServiceIcon/>,
		link: 'https://nazr.razavi.ir/pay'
	},
	{
		id: 22,
		name: 'marriage_service',
		icon: <MarrigeServiceIcon/>,
		link: 'https://kouthar.razavi.ir/aghd/'
	},
	{
		id: 25,
		name: 'virtual_pilgrimage',
		icon: <VirtualPilgrimageServiceIcon/>,
		link: 'https://www.razavi.ir/fa/liveharam'
	},
	{
		id: 20,
		name: 'library_service',
		icon: <LibraryServiceIcon/>,
		link: 'https://register.library.razavi.ir/azarsa-astan-register'
	},
	{
		id: 23,
		name: 'museum_service',
		icon: <MuseumServiceIcon/>,
		link: 'https://digimuseum.razavi.ir'
	},
	{
		id: 7,
		name: 'pray_service',
		icon: <PrayServiceIcon/>,
		link: '/prayer',
		isLocal: true
	},
	{
		id: 27,
		name: 'servant_service',
		icon: <ServantServiceIcon/>,
		link: 'https://khademyar.razavi.ir/panel/f?p=100%3A101'
	},
	{
		id: 28,
		name: 'handling_complaints',
		icon: <HandlingComplintsService/>,
		link: 'https://shekayat.razavi.ir/register'
	},
	{
		id: 21,
		name: 'military_service',
		icon: <MilitaryServiceIcon/>,
		link: 'https://khedmat.razavi.ir/register'
	},
	{
		id: 19,
		name: 'public_supervision',
		icon: <PublicSupervisionServiceIcon/>,
		link: 'https://138.razavi.ir/peygiri/request'
	},
	{
		id: 29,
		name: 'i_like_quran',
		icon: <LikeQuranService/>,
		link: '/quran',
		isLocal: true
	},
	{
		id: 31,
		name: 'shrine_programs',
		icon: <ShrineProgramServiceIcon/>,
		link: '/network/17',
		isLocal: true
	},
	{
		id: 30,
		name: 'photo_event_emem_hosein',
		icon: <PhotoEventServiceIcon/>,
		link: 'https://www.razavi.ir/fa/343938/%D9%BE%D9%88%DB%8C%D8%B4-%D9%85%D9%86-%DB%8C%D8%A7%D8%B1-%D8%AD%D8%B3%DB%8C%D9%86%D9%85'
	}
	// {
	// 	id: 1,
	// 	name: 'calendar',
	// 	icon: <CalendarServiceIcon/>,
	// 	link: '/calendar',
	// 	isLocal: true
	// },
	// {
	// 	id: 10,
	// 	name: 'culture_competition',
	// 	icon: <CompetitionServiceIcon/>,
	// 	link: '/competition',
	// 	isLocal: true
	// },
	// {
	// 	id: 5,
	// 	name: 'radio_razavi',
	// 	icon: <RadioServiceIcon/>,
	// 	link: '/radio',
	// 	isLocal: true
	// },
	// {
	// 	id: 8,
	// 	name: 'routing',
	// 	icon: <RoutingServiceIcon/>,
	// 	link: '/routing',
	// 	isLocal: true
	// },
	// {
	// 	id: 2,
	// 	name: 'hotel_service',
	// 	icon: <HotelServiceIcon/>,
	// 	link: 'https://zaer.razavi.ir'
	// },
	// {
	// 	id: 11,
	// 	name: 'pilgrimage',
	// 	icon: <PilgrimageServiceIcon/>,
	// 	link: 'https://haram.razavi.ir/ziyarat'
	// },
	// {
	// 	id: 4,
	// 	name: 'charity_service',
	// 	icon: <CharityServiceIcon/>,
	// 	link: 'https://nazr.razavi.ir/pay'
	// },
	// {
	// 	id: 22,
	// 	name: 'marriage_service',
	// 	icon: <MarrigeServiceIcon/>,
	// 	link: 'https://kouthar.razavi.ir/aghd/'
	// },
	// {
	// 	id: 25,
	// 	name: 'virtual_pilgrimage',
	// 	icon: <VirtualPilgrimageServiceIcon/>,
	// 	link: 'https://www.razavi.ir/fa/liveharam'
	// },
	// {
	// 	id: 20,
	// 	name: 'library_service',
	// 	icon: <LibraryServiceIcon/>,
	// 	link: 'https://register.library.razavi.ir/azarsa-astan-register'
	// },
	// {
	// 	id: 23,
	// 	name: 'museum_service',
	// 	icon: <MuseumServiceIcon/>,
	// 	link: 'https://digimuseum.razavi.ir'
	// },
	// {
	// 	id: 7,
	// 	name: 'pray_service',
	// 	icon: <PrayServiceIcon/>,
	// 	link: '/prayer',
	// 	isLocal: true
	// },
	// {
	// 	id: 27,
	// 	name: 'servant_service',
	// 	icon: <ServantServiceIcon/>,
	// 	link: 'https://khademyar.razavi.ir/panel/f?p=100%3A101'
	// },
	// {
	// 	id: 28,
	// 	name: 'handling_complaints',
	// 	icon: <HandlingComplintsService/>,
	// 	link: 'https://shekayat.razavi.ir/register'
	// },
	// {
	// 	id: 21,
	// 	name: 'military_service',
	// 	icon: <MilitaryServiceIcon/>,
	// 	link: 'https://khedmat.razavi.ir/register'
	// },
	// {
	// 	id: 19,
	// 	name: 'public_supervision',
	// 	icon: <PublicSupervisionServiceIcon/>,
	// 	link: 'https://138.razavi.ir/peygiri/request'
	// },
	// {
	// 	id: 29,
	// 	name: 'i_like_quran',
	// 	icon: <LikeQuranService/>,
	// 	link: '/quran',
	// 	isLocal: true
	// },
	// {
	// 	id: 31,
	// 	name: 'shrine_programs',
	// 	icon: <ShrineProgramServiceIcon/>,
	// 	link: '/network/17',
	// 	isLocal: true
	// },
	// {
	// 	id: 30,
	// 	name: 'photo_event_emem_hosein',
	// 	icon: <PhotoEventServiceIcon/>,
	// 	link: 'https://www.razavi.ir/fa/343938/%D9%BE%D9%88%DB%8C%D8%B4-%D9%85%D9%86-%DB%8C%D8%A7%D8%B1-%D8%AD%D8%B3%DB%8C%D9%86%D9%85'
	// }
];

interface IProps {
	service: IService;
	patternIcon?: boolean;
	color?: string;
}

export default function ServicesColoredList(props: IProps) {
	const {service, patternIcon, color} = props;
	const {t} = useTranslation();
	const name = t(`services_list.${service.name}`);
	const servicesColoredList: IColorService = {
		'calendar': {
			icon: <CalendarServiceIcon color={color}/>
		},
		'parking': {
			icon: <ParkingServiceIcon color={color}/>
		},
		'radio_razavi': {
			icon: <RadioServiceIcon color={color}/>
		},
		'culture_competition': {
			icon: <CompetitionServiceIcon color={color}/>
		},
		'routing': {
			icon: <RoutingServiceIcon color={color}/>
		},
		'hotel_service': {
			icon: <HotelServiceIcon color={color}/>
		},
		'pilgrimage': {
			icon: <PilgrimageServiceIcon color={color}/>
		},
		'charity_service': {
			icon: <CharityServiceIcon color={color}/>
		},
		'marriage_service': {
			icon: <MarrigeServiceIcon color={color}/>
		},
		'virtual_pilgrimage': {
			icon: <VirtualPilgrimageServiceIcon color={color}/>
		},
		'library_service': {
			icon: <LibraryServiceIcon color={color}/>
		},
		'museum_service': {
			icon: <MuseumServiceIcon color={color}/>
		},
		'pray_service': {
			icon: <PrayServiceIcon color={color}/>
		},
		'servant_service': {
			icon: <ServantServiceIcon color={color}/>
		},
		'handling_complaints': {
			icon: <HandlingComplintsService/>
		},
		'military_service': {
			icon: <MilitaryServiceIcon color={color}/>
		},
		'public_supervision': {
			icon: <PublicSupervisionServiceIcon color={color}/>
		},
		'i_like_quran': {
			icon: <LikeQuranService/>
		},
		'shrine_programs': {
			icon: <ShrineProgramServiceIcon color={color}/>
		},
		'photo_event_emem_hosein': {
			icon: <PhotoEventServiceIcon color={color}/>
		},
		'channels_list': {
			icon: <ChannelsServiceIcon color={color}/>
		}

//'calendar':	{
		// 	icon: <CalendarServiceIcon color={color}/>,
		// },
//'culture_competition':	{
		// 	icon: <CompetitionServiceIcon color={color}/>,
		// },
//'radio_razavi':	{
		// 	icon: <RadioServiceIcon color={color}/>,
		// },
//'routing':	{
		// 	icon: <RoutingServiceIcon color={color}/>,
		// },
//'hotel_service':	{
		// 	icon: <HotelServiceIcon color={color}/>,
		// },
//'pilgrimage':	{
		// 	icon: <PilgrimageServiceIcon color={color}/>,
		// },
//'charity_service':	{
		// 	icon: <CharityServiceIcon color={color}/>,
		// },
//'marriage_service':	{
		// 	icon: <MarrigeServiceIcon color={color}/>,
		// },
//'virtual_pilgrimage':	{
		// 	icon: <VirtualPilgrimageServiceIcon color={color}/>,
		// },
//'library_service':	{
		// 	icon: <LibraryServiceIcon color={color}/>,
		// },
//'museum_service':	{
		// 	icon: <MuseumServiceIcon color={color}/>,
		// },
//'pray_service':	{
		// 	icon: <PrayServiceIcon color={color}/>,
		// },
//'servant_service':	{
		// 	icon: <ServantServiceIcon color={color}/>,
		// },
//'handling_complaints':	{
		// 	icon: <HandlingComplintsService/>,
		// },
//'military_service':	{
		// 	icon: <MilitaryServiceIcon color={color}/>,
		// },
//'public_supervision':	{
		// 	icon: <PublicSupervisionServiceIcon color={color}/>,
		// },
//'i_like_quran':	{
		// 	icon: <LikeQuranService/>,
		// },
//'shrine_programs':	{
		// 	icon: <ShrineProgramServiceIcon color={color}/>,
		// },
//'photo_event_emem_hosein':	{
		// 	icon: <PhotoEventServiceIcon color={color}/>,
		// }
	};
	if (service.isLocal) {
		return (
			<Link to={service.link} className="flex flex-col space-y-1 items-center text-center">
				{
					patternIcon ? (
							<ServicePatternIcon>
								{servicesColoredList[service.name]?.icon}
							</ServicePatternIcon>
						) :
						(
							servicesColoredList[service.name]?.icon
						)
				}
				<Typography className="min-h-8" sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
					fontSize: (theme) => theme.typography.fontSize - 3
				}}>{name}</Typography>
			</Link>
		);
	} else if (service.link) {
		return (
			<a href={service.link} className="flex flex-col space-y-1 items-center text-center">
				{
					patternIcon ? (
							<ServicePatternIcon>
								{servicesColoredList[service.name]?.icon}
							</ServicePatternIcon>
						) :
						(
							servicesColoredList[service.name]?.icon
						)
				}
				<Typography className="min-h-8" sx={{
					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
					fontSize: (theme) => theme.typography.fontSize - 3
				}}>{name}</Typography>
			</a>
		);
	} else {
		return (
			<Tooltip title={t('soon')} placement="top" enterTouchDelay={0}>
				<div className="flex flex-col space-y-1 items-center text-center disabled-service">
					<div style={{opacity: 0.4}}>
						{
							patternIcon ? (
									<ServicePatternIcon>
										{servicesColoredList[service.name]?.icon}
									</ServicePatternIcon>
								) :
								(
									servicesColoredList[service.name]?.icon
								)
						}
					</div>
					<Typography className="h-8" sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.300',
						opacity: 0.7,
						fontSize: (theme) => theme.typography.fontSize - 3
					}}>{name}</Typography>
				</div>
			</Tooltip>
		);
	}
	// return servicesColoredList[service.name].icon;
}


export {
	servicesList,
	ServicesColoredList
};
